/*

THIS REDUCER IS USED TO SAVE SELECTED OPTIONS IN THE SHIPPING METHOD 

*/

import * as types from '../actions/actionTypes';

export const bookingReducer = (state = {date: '', option_code: '', day_code: '', time_window_code: '', note: '', source: '', remote_id: ''}, action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_BOOKING:
            newState = {...action.payload}
            return newState;
            break; 
        default:
            return state;
    }
}
